exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=\"file\"][data-v-310ad020] {\n  display: none;\n}\nimg[data-v-310ad020] {\n  max-width: 100%;\n  margin: 0 auto;\n  display: block;\n  margin-bottom: 10px;\n}\n.overlay-wrapper .overlay[data-v-310ad020] {\n  visibility: hidden;\n}\n.overlay-wrapper:hover .overlay[data-v-310ad020] {\n  visibility: visible;\n}\n", ""]);

// exports
